import React, { useState } from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-border-custom last:border-0" data-id="element-44">
      <button className="w-full py-6 flex items-center justify-between text-left focus:outline-none group" onClick={() => setIsOpen(!isOpen)} aria-expanded={isOpen} data-id="element-45">
        <span className="text-lg font-medium text-text group-hover:text-plum transition-colors pr-8" data-id="element-46">
          {question}
        </span>
        {isOpen ? <ChevronUp className="w-5 h-5 text-plum flex-shrink-0" data-id="element-47" /> : <ChevronDown className="w-5 h-5 text-text-secondary group-hover:text-plum flex-shrink-0" data-id="element-48" />}
      </button>

      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 mb-6' : 'max-h-0 opacity-0'}`} data-id="element-49">
        <p className="text-text-secondary leading-relaxed pr-8" data-id="element-50">{answer}</p>
      </div>
    </div>;
}
export function FAQSection() {
  const faqs = [{
    question: '¿Necesito experiencia previa en meditación?',
    answer: 'No. Este no es un curso de meditación tradicional. Es un sistema técnico de regulación. No necesitás poner la mente en blanco ni sentarte en loto. Son herramientas prácticas para usar en tu día a día.'
  }, {
    question: '¿Cuánto tiempo me va a llevar?',
    answer: 'El sistema está diseñado para mujeres ocupadas. Las prácticas de descarga toman 5 minutos. La armonización completa, menos de 15. La idea es que ganes tiempo al dejar de perderlo en estados emocionales drenantes.'
  }, {
    question: '¿Es compatible si ya hago terapia?',
    answer: "Absolutamente. ProMind Energy no reemplaza la terapia, la complementa. Mientras la terapia trabaja sobre tus procesos psicológicos, este sistema te da herramientas somáticas y energéticas para gestionar el 'ahora'."
  }, {
    question: '¿Cómo accedo al material?',
    answer: 'Inmediatamente después de tu compra recibís un correo con tus datos de acceso a nuestra plataforma privada. Podés entrar desde tu computadora, tablet o celular.'
  }];
  return <SectionWrapper narrow data-id="element-51">
      <h2 className="text-3xl md:text-4xl text-text text-center mb-12" data-id="element-52">
        Preguntas Frecuentes
      </h2>
      <div className="border-t border-border-custom" data-id="element-53">
        {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-54" />)}
      </div>
    </SectionWrapper>;
}